module.exports = __webpack_public_path__ + "static/media/PM132.38070c6f.png";